export default __webpack_public_path__ + "d59af6af2f821c0b95d35e65454755ac.svg";